export const actions = {
  SHOW: 'SHOW',
  HIDE: 'HIDE',
  DELETE: 'DELETE',
};
